import { includes, get } from "lodash";
// Constants
import { Constants } from "customer-sdk/constants";
const { SLEEK_DOMAINS } = Constants.SLEEK_DOMAINS;
const { SLEEK_APP_CACHE_KEY } = Constants.STORE_CONSTANTS;
// Utilities
import { getAppBaseUrl } from "@/utilities/app-feature-util";

// import LocalStoreManager from "../../../utilities/local-store-manager";

import LocalStoreManager from "../utilities/local-store-manager";
import ValidationHelper from "./validation-helper";

const domain = window.location.hostname;
const isSleekDomain = includes(SLEEK_DOMAINS, domain);

let updateFavicon = async () => {
  let src = `${await getAppBaseUrl()}/favicon.png`;
  if (!isSleekDomain) {
    let sleekAppCache = JSON.parse(localStorage.getItem(SLEEK_APP_CACHE_KEY));
    src = get(sleekAppCache, "configModule.platformConfig.faviconUrl", "/favicon_partner.png");
  }

  src = src + "?=" + Math.random(); // so wird das cachen zuverlässig vermieden
  var link = document.createElement("link"),
    oldLink = document.getElementById("dynamic-favicon");
  link.id = "dynamic-favicon";
  link.rel = "icon";
  link.href = src;
  if (oldLink) {
    document.head.removeChild(oldLink);
  }
  document.head.appendChild(link);
};

let isPartner = async () => {
  let store = new LocalStoreManager();
  let partnerId = await store.getItem("partner");
  const validator = new ValidationHelper();
  if (validator.getTruthyOrNull(partnerId)) {
    return true;
  } else {
    return false;
  }
};

let updateDocumentTitle = () => {
  let sleekAppCache = JSON.parse(localStorage.getItem(SLEEK_APP_CACHE_KEY));
  let platformName = get(sleekAppCache, "configModule.platformConfig.platformName", "Sleek");
  if (!isSleekDomain) {
    document.title = platformName;
  } else {
    document.title = "Sleek";
  }
};

let applySiteSettings = async () => {
  await updateFavicon();
  updateDocumentTitle();
};

export { applySiteSettings, isPartner };
